import { ref } from "vue";

type PopupType = "success" | "error" | "info" | "confirm";

interface PopupMessage {
  id: number;
  message: string;
  type: PopupType;
  duration?: number;
  resolve?: (value: boolean) => void;
}

const popups = ref<PopupMessage[]>([]);

export function usePopup() {
  const show = (
    message: string,
    type: PopupType = "info",
    duration = 3000,
  ): void => {
    const id = Date.now();
    popups.value.push({ id, message, type, duration });

    if (type !== "confirm") {
      setTimeout(() => {
        popups.value = popups.value.filter((p) => p.id !== id);
      }, duration);
    }
  };

  const confirm = (message: string): Promise<boolean> => {
    return new Promise((resolve) => {
      const id = Date.now();
      popups.value.push({ id, message, type: "confirm", resolve });
    });
  };

  const closePopup = (id: number, confirmed?: boolean) => {
    const popup = popups.value.find((p) => p.id === id);
    if (popup?.type === "confirm" && popup.resolve) {
      popup.resolve(confirmed ?? false);
    }
    popups.value = popups.value.filter((p) => p.id !== id);
  };

  return {
    popups,
    showSuccess: (msg: string, duration?: number) =>
      show(msg, "success", duration),
    showError: (msg: string, duration?: number) => show(msg, "error", duration),
    showInfo: (msg: string, duration?: number) => show(msg, "info", duration),
    confirm,
    closePopup,
  };
}
